import Plyr from 'plyr';
const player = new Plyr('#player', {
    controls:['play-large', 'play', 'progress', 'fullscreen'],
    fullscreen: {
        enable:true, 
        fallback: true, 
        iosNative: true
    }
    
});

playlistHeight();

player.on('ended', function(){
    player.stop();
});

//On Window Resize
window.addEventListener('resize', function() {
   playlistHeight();
}, true);

function playlistHeight(){
    var videoWidth = document.querySelector('#player').offsetWidth; 
    var videoBoxWidth = document.querySelector('.plyr-box').offsetWidth; 
    var playlistHeight = document.querySelector('.plyr-playlist');
    if (videoWidth < 938 && videoBoxWidth > 800) {
        var videoHeight = videoWidth / 1.778; 
        playlistHeight.style.maxHeight= videoHeight + 'px';
    } 
}

//Click Overlay to Play
var overlayBG = document.querySelector('.plyr-box .overlay-bg');
overlayBG.addEventListener('click', function(){
    player.togglePlay();
});

//Playlist Links
var plyr = document.querySelector('.plyr--video');
var playlist = document.querySelectorAll('.plyr-playlist a');
playlist.forEach(function(link){
    link.addEventListener('click', function(e){
        e.preventDefault();
        var videoID = link.dataset.video_id;
        var videoTitle = link.dataset.video_title;
        plyr.setAttribute("data-btn", "hide-btn");
        plyr.setAttribute("data-loading", "loading");
        

        player.source = {
            type: 'video',
            title: videoTitle,
            autoplay: true,
            muted: true,
            volume: 0,
            controls: false, 
            sources: [
                {
                    src: 'https://player.vimeo.com/video/' + videoID + '?loop=false&autoplay=false&muted=false&gesture=media&playsinline=true&byline=false&portrait=false&title=false&speed=true&transparent=false&customControls=true',
                    provider: 'vimeo'
                }
            ]
        };

        // Play the video
        player.play().then(() => {
            // Unmute the player after it starts playing
            player.muted = false;
        }).catch(error => {
            console.error('Error attempting to play the video:', error);
        });
    });
});

var groupName = document.querySelectorAll('.group-name span');

groupName.forEach(function(link){
    link.addEventListener('click', function(e){
        e.preventDefault();
        link.parentElement.classList.toggle('close');
    });
});